import { render, staticRenderFns } from "./PhieuThuCoGamLayout.vue?vue&type=template&id=eee1e21e"
import script from "./PhieuThuCoGamLayout.vue?vue&type=script&lang=js"
export * from "./PhieuThuCoGamLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports